import { createStyles, makeStyles } from '@material-ui/core';

const borderWidth = 2;
const useStyle = makeStyles((theme) =>
    createStyles({
        root: {
            padding: `${theme.spacing(1)}px ${theme.spacing(3)}px`,
            border: `solid ${borderWidth}px ${theme.palette.primary.main}`
        },
        widerRoot: { padding: `0 ${theme.spacing(4)}px` },
        underline: {
            borderRadius: 0,
            padding: 0,
            borderBottom: `solid ${borderWidth}px transparent`,
            '&:hover': { borderColor: theme.palette.primary.main }
        },
        borderButton: {
            color: theme.palette.primary.main
        },
        lightBorderText: { '&:hover': {} },
        lightBorderButton: {
            '&:hover': {
                border: `solid 2px ${theme.palette.grey[500]}`,
                color: theme.palette.grey[500]
            }
        },
        darkBorderText: { '&:hover': {} },
        darkBorderButton: { '&:hover': { border: 'solid 2px #FFF', color: '#FFF' } },
        lightFillButton: {
            '&:hover': { backgroundColor: '#FFF', borderColor: theme.palette.grey[500] }
        },
        darkFillButton: { '&:hover': { backgroundColor: theme.palette.grey['100'] } },
        fillButton: {
            boxShadow: 'none',
            '&:hover': { boxShadow: 'none' },
            color: theme.palette.grey[500]
        },
        fillButtonHover: {},
        submitWrapper: { display: 'flex', alignItems: 'center', justifyContent: 'center' }
    })
);

export default useStyle;
